import type { CatalogueApiService, OgcApiService } from '@angular-workspace/services';
import { parseStacItemAssets } from './stac-assets.util';

/** Detect OGC raster from catalogue `resourceServer[].queryTypes` containing STAC. */
export function inferOgcRasterFromCatalogueItem(
  item: Record<string, unknown> | null | undefined,
): boolean {
  if (!item) return false;
  const rs = item['resourceServer'] ?? item['resource_server'];
  const rsArray: unknown[] = Array.isArray(rs) ? rs : rs ? [rs] : [];
  for (const entry of rsArray) {
    if (entry && typeof entry === 'object') {
      const qt = (entry as Record<string, unknown>)['queryTypes'];
      if (Array.isArray(qt) && qt.includes('STAC')) {
        return true;
      }
    }
  }
  return false;
}

/** True when the STAC item has at least one asset with a valid href. */
export async function stacItemHasAssets(
  ogcApi: OgcApiService,
  collectionId: string,
  itemId?: string | null,
): Promise<boolean> {
  const catalogueItemId = collectionId.trim();
  if (!catalogueItemId) return false;

  let stacItemId = itemId?.trim() ?? '';
  if (!stacItemId) {
    try {
      const collection = await ogcApi.listStacItems(catalogueItemId);
      const features = collection.features ?? collection.items ?? [];
      stacItemId = String(features[0]?.id ?? '').trim();
    } catch (error) {
      console.warn('Could not list STAC items for dataUploadStatus sync:', error);
      return false;
    }
  }

  if (!stacItemId) return false;

  try {
    const item = await ogcApi.getStacItem(catalogueItemId, stacItemId);
    return parseStacItemAssets(item.assets as Record<string, unknown> | undefined).length > 0;
  } catch (error) {
    console.warn('Could not fetch STAC item for dataUploadStatus sync:', error);
    return false;
  }
}

/** PATCH organisation asset dataUploadStatus based on STAC item asset presence. */
export async function syncRasterDataUploadStatus(
  catalogueApi: CatalogueApiService,
  ogcApi: OgcApiService,
  catalogueItemId: string,
  stacItemId?: string | null,
): Promise<void> {
  const assetId = catalogueItemId.trim();
  if (!assetId) return;

  try {
    const hasAssets = await stacItemHasAssets(ogcApi, assetId, stacItemId);
    await catalogueApi.postPublishAssets(assetId, { dataUploadStatus: hasAssets });
  } catch (error) {
    console.error('Failed to sync raster dataUploadStatus:', error);
  }
}
